// src/utils/tile/request.ts
import { getURLFromTemplate } from "@antv/l7-utils";
function getTileUrl(url, tileParams) {
  if (Array.isArray(url)) {
    if (typeof url[0] === "string") {
      return url.map((src) => getURLFromTemplate(src, tileParams));
    } else {
      return url.map((o) => {
        return {
          url: getURLFromTemplate(o.url, tileParams),
          bands: o.bands || [0]
        };
      });
    }
  } else {
    return getURLFromTemplate(url, tileParams);
  }
}
function getTileBandParams(urlBandParam) {
  if (typeof urlBandParam === "string") {
    return [
      {
        url: urlBandParam,
        bands: [0]
      }
    ];
  } else if (typeof urlBandParam[0] === "string") {
    return urlBandParam.map((param) => {
      return {
        url: param,
        bands: [0]
      };
    });
  } else {
    return urlBandParam;
  }
}
function bindCancel(tile, xhrList) {
  tile.xhrCancel = () => {
    xhrList.map((xhr) => {
      xhr.abort();
    });
  };
}
export {
  bindCancel,
  getTileBandParams,
  getTileUrl
};
